"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.AzureLogRecordProcessor = void 0;
const index_js_1 = require("../shared/logging/index.js");
/**
 * Azure Monitor LogRecord Processor.
 * @internal
 */
class AzureLogRecordProcessor {
    _metricHandler;
    constructor(metricHandler) {
        this._metricHandler = metricHandler;
    }
    onEmit(logRecord) {
        try {
            this._metricHandler.recordLog(logRecord);
        }
        catch (error) {
            index_js_1.Logger.getInstance().warn("Error while recording log", error);
        }
    }
    forceFlush() {
        return Promise.resolve();
    }
    shutdown() {
        return Promise.resolve();
    }
}
exports.AzureLogRecordProcessor = AzureLogRecordProcessor;
//# sourceMappingURL=logRecordProcessor.js.map